import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import { openModal, OpenModal } from 'src/actions/modal';
import RegisterContainer from 'src/modules/modals/register/Register.container';
import InvestorDeck from 'src/entities/InvestorDeck';
import ShowInvestorDeckComponent from 'src/modules/investor-deck/ShowInvestorDeck.component';
import { getInvestorDeck, GetInvestorDeckAction } from 'src/actions/investor-deck/get/GetInvestorDeck.actions';
import { getUser, GetUserAction } from 'src/actions/user/get/GetUser.actions';
import Person from 'src/entities/Person';

interface StateProps {
  isLogged: boolean;
  investorDeck?: InvestorDeck;
  loggedUserData?: number | null;
  activeProfile?: Person;
}

interface DispatchProps {
  openModal: (content: JSX.Element) => void;
  getInvestorDeck: (personId: number, personType: string) => Promise<GetInvestorDeckAction>;

  getUser(userId: number): Promise<GetUserAction>;
}

interface Props extends DispatchProps, StateProps {
}

class ShowInvestorDeckContainer extends React.Component<Props> {

  public componentWillMount(): void {
    if (this.props.loggedUserData) {
      if (this.props.activeProfile) {
        this.props.getInvestorDeck(this.props.activeProfile.id, this.props.activeProfile.personType);
      } else {
        this.props.getUser(this.props.loggedUserData!).then(() => {
          this.props.getInvestorDeck(this.props.activeProfile!.id, this.props.activeProfile!.personType);
        });
      }
    }
  }

  public componentWillReceiveProps(newProps: Props): void {
    if (this.props.activeProfile !== newProps.activeProfile && newProps.activeProfile) {
      newProps.getInvestorDeck(newProps.activeProfile.id, newProps.activeProfile.personType);
    }
  }

  public render(): React.ReactNode {
    if (this.props.isLogged && this.props.investorDeck) {
      return (
        <ShowInvestorDeckComponent
          isLogged={this.props.isLogged}
          hasInvestorDeck={true}
          register={() => this.register()}
        />
      );
    } else {
      return (
        <ShowInvestorDeckComponent
          isLogged={this.props.isLogged}
          hasInvestorDeck={false}
          register={() => this.register()}
        />
      );
    }
  }

  private register(): void {
    this.props.openModal(
      <RegisterContainer/>
    );
  }
}

const mapStateToProps: (state: RootState) => StateProps = (state: RootState):
  StateProps => ({
  isLogged: state.authentication.isLogged,
  loggedUserData: state.authentication.loggedUserData,
  investorDeck: state.getInvestorDeck.investorDeck,
  activeProfile: state.getUser.activeProfile,
});

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => {

  return {
    openModal: (content: JSX.Element): OpenModal => (
      dispatch(openModal(content))
    ),
    getInvestorDeck: (personId: number, personType: string): Promise<GetInvestorDeckAction> => (
      dispatch(getInvestorDeck(personId, personType))
    ),
    getUser: (userId: number): Promise<GetUserAction> => (
      dispatch(getUser(userId))
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShowInvestorDeckContainer);


// WEBPACK FOOTER //
// ./src/modules/investor-deck/ShowInvestorDeck.container.tsx